export type SocialNetwork = 'whatsapp' | 'instagram' | 'facebook' | 'tiktok'

export interface FooterSocialLinks {
  whatsapp: string
  instagram: string
  facebook: string
  tiktok: string
}

export const DEFAULT_FOOTER_SOCIAL_LINKS: FooterSocialLinks = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  tiktok: '',
}

export const SOCIAL_NETWORKS: Array<{
  key: SocialNetwork
  label: string
  icon: string
  placeholder: string
}> = [
  {
    key: 'whatsapp',
    label: 'WhatsApp',
    icon: 'i-simple-icons-whatsapp',
    placeholder: 'https://wa.me/40774409823',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    icon: 'i-simple-icons-instagram',
    placeholder: 'https://instagram.com/...',
  },
  {
    key: 'facebook',
    label: 'Facebook',
    icon: 'i-simple-icons-facebook',
    placeholder: 'https://facebook.com/...',
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    icon: 'i-simple-icons-tiktok',
    placeholder: 'https://tiktok.com/@...',
  },
]

export function parseFooterSocialLinks(raw?: string | null): FooterSocialLinks {
  if (!raw) return { ...DEFAULT_FOOTER_SOCIAL_LINKS }
  try {
    const parsed = JSON.parse(raw) as Partial<FooterSocialLinks>
    return { ...DEFAULT_FOOTER_SOCIAL_LINKS, ...parsed }
  } catch {
    return { ...DEFAULT_FOOTER_SOCIAL_LINKS }
  }
}

export function resolveSocialUrl(network: SocialNetwork, value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return ''

  if (network === 'whatsapp') {
    if (/^https?:\/\//i.test(trimmed)) return trimmed
    const digits = trimmed.replace(/\D/g, '')
    if (!digits) return ''
    if (digits.startsWith('40')) return `https://wa.me/${digits}`
    if (digits.startsWith('0')) return `https://wa.me/4${digits}`
    return `https://wa.me/${digits}`
  }

  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
}

export function buildFooterSocialItems(links: FooterSocialLinks) {
  return SOCIAL_NETWORKS
    .map((network) => ({
      key: network.key,
      label: network.label,
      icon: network.icon,
      url: resolveSocialUrl(network.key, links[network.key]),
    }))
    .filter((item) => item.url)
}
